import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'radio-check',
  shadow: false,
  styleUrl: 'radio-check.css',
})
export class InputText {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() required: boolean;
  @Prop() type: string;
  @Prop() tooltip: string;
  @Prop() elements: Array<{ name: string; id: string; label: string }>;
  @Prop() disabled: boolean;
  @Prop() dataTab: string;

  render() {
    return (
      <div class="form-check form-check-inline mb-3">
        <input class="form-check-input" type="checkbox" name={this.name} disabled={this.disabled} data-tab={this.dataTab} />
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
      </div>
    );
  }
}
